'use client';

import PopupResponsive from '@/components/PopupResponsive';
import { RightArrowOutlined } from '@zeelool/icon';
import React, { useState } from 'react';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useContext } from 'react';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';

interface PromotionScheduleData {
  label_text: string;
  label_color: string;
  label_background_color: string;
  popup_title: string;
  popup_description: string;
  btn_name: string;
  show_status: number;
}

interface PromotionScheduleTagProps {
  data: PromotionScheduleData | null;
  className?: string;
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
}

export default function PromotionScheduleTag({
  data,
  className = '',
  SDProductDetailsPageBtnClick,
}: PromotionScheduleTagProps) {
  const [showDialog, setShowDialog] = useState(false);
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;

  if (!data) {
    return null;
  }

  const handleClick = () => {
    setShowDialog(true);
    SDProductDetailsPageBtnClick?.(data.btn_name);
  };

  const getHtmlText = (html: string): string => {
    if (!html) return '';
    return html;
  };

  return (
    <>
      <p
        onClick={handleClick}
        className={`${isWeb ? 'pl-[8px] pr-[4px] py-[4px] rounded-[4px] text-[14px] leading-[17px]' : 'px-[5px] py-[3px] rounded-[4px] text-[12px] leading-[14px]'} flex items-center cursor-pointer ${className}`}
        style={{
          color: data.label_color || '#282828',
          backgroundColor: data.label_background_color || '#EEEEEE',
        }}
      >
        <span>{data.label_text}</span>
        <RightArrowOutlined className={`${isWeb ? 'text-[16px]' : 'text-[13px]'} ml-[8px]`} />
      </p>
      <PopupResponsive
        open={showDialog}
        onClose={() => setShowDialog(false)}
        title={data.popup_title}
        position="bottom"
        showDivider
        closeOnClickOverlay={false}
        sx={{
          '& .popup-content': {
            padding: '16px 14px',
            overflowX: 'hidden',
          },
          '& .MuiBox-root': {
            maxHeight: '80vh',
          },
        }}
      >
        <div className="box-border">
          <div
            className="text-[12px] leading-[18px] lg:text-[14px] lg:leading-[22px] font-ir"
            dangerouslySetInnerHTML={{ __html: getHtmlText(data.popup_description) }}
          />
        </div>
      </PopupResponsive>
    </>
  );
}
